export default {
  'ff.nav.market': 'Market',
  'ff.market.tab.trade': 'Trade Market',
  'ff.market.tab.myOrders': 'My Orders',
  'ff.market.tab.history': 'History',
  'ff.market.title': 'Trade Market',
  'ff.market.badge.new': 'NEW',
  'ff.market.subtitle': 'Select an item below, then tap BUY or SELL to trade.',
  'ff.market.balance': 'Balance',
  'ff.market.listHeading': 'TRADING ITEMS',
  'ff.market.bundleRank': 'RANK IN BUNDLE',
  'ff.market.fashionRank': 'RANK IN FASHION',
  'ff.market.avgSellPrice': 'AVG SELL PRICE',
  'ff.market.floorPrice': 'Floor price',
  'ff.market.quantity': 'Quantity',
  'ff.market.avgSold': 'Avg sold',
  'ff.market.selecting': 'Selecting',
  'ff.market.sell': 'SELL',
  'ff.market.buy': 'BUY',
  'ff.market.comingSoon': 'Coming soon',
  // My Orders tab
  'ff.market.myOrders.title': 'My Orders',
  'ff.market.myOrders.subtitle': 'Ongoing transactions. Items/diamonds ready will have a CLAIM button.',
  'ff.market.filter.selling': 'Selling',
  'ff.market.filter.buying': 'Buying',
  'ff.market.filter.claimable': 'Claimable',
  'ff.market.filter.history': 'My history',
  'ff.market.claimAll': 'Claim all',
  'ff.market.col.item': 'ITEM',
  'ff.market.col.type': 'TYPE',
  'ff.market.col.price': 'PRICE',
  'ff.market.col.quantity': 'QTY',
  'ff.market.col.status': 'STATUS',
  'ff.market.col.action': 'ACTION',
  'ff.market.type.sell': 'SELL',
  'ff.market.type.buy': 'BUY',
  'ff.market.status.selling': 'SELLING',
  'ff.market.status.sold': 'SOLD',
  'ff.market.status.buying': 'BUYING',
  'ff.market.status.bought': 'BOUGHT',
  'ff.market.status.claimed': 'CLAIMED',
  'ff.market.status.cancelled': 'CANCELLED',
  'ff.market.action.cancel': 'CANCEL',
  'ff.market.action.claimDiamond': 'CLAIM',
  'ff.market.action.claimItem': 'CLAIM ITEM',
  'ff.market.empty': 'No orders',
  // Terms confirmation modal
  'ff.market.terms.title': 'TRADE MARKET TERMS',
  'ff.market.terms.heading': 'ALL REAL-MONEY TRADES OUTSIDE THE GAME ARE PROHIBITED.',
  'ff.market.terms.penalty': 'Violations will result in your account being',
  'ff.market.terms.penaltyHighlight': 'permanently banned',
  'ff.market.terms.disagree': 'DISAGREE',
  'ff.market.terms.agree': 'AGREE',
  // Age verification modal
  'ff.market.age.title': 'AGE VERIFICATION',
  'ff.market.age.badge': '16+',
  'ff.market.age.detail': 'The Trade Market is only for players aged 16 and above.',
  'ff.market.age.placeholder': 'Your year of birth',
  'ff.market.age.ok': 'OK',
  'ff.market.age.invalid': 'You must be at least 16 years old.',
  // Place order modal (buy / sell)
  'ff.market.order.buyTitle': 'PLACE BUY PRICE',
  'ff.market.order.sellTitle': 'PLACE SELL PRICE',
  'ff.market.order.buyNote': 'After buying, you cannot resell this item for 2 weeks.',
  'ff.market.order.sellNote': 'A listing fee applies once the item is sold.',
  'ff.market.order.priceHint': 'Price must be a multiple of 10. The system auto-matches the cheapest listing ≤ your price.',
  'ff.market.order.invalidPrice': 'Enter a price that is a multiple of 10.',
  'ff.market.order.insufficient': 'Insufficient balance.',
  'ff.market.order.balance': 'Balance',
  'ff.market.order.cancel': 'CANCEL',
  'ff.market.order.confirmBuy': 'BUY',
  'ff.market.order.confirmSell': 'SELL',
  'ff.market.order.success': 'Order placed successfully.',
};
